module.exports = __webpack_public_path__ + "43161ecc323c52baa4bc96732693aebc.png";